import React from 'react';
import styles from './CtaButton.module.css';
import {useTranslation} from "react-i18next";


const CtaButtonHover: React.FC<({link: string, buttonTxt: string})> = props => {

    const { t, i18n } = useTranslation(); // Use the translation hook

    const currentLanguage = i18n.language; // Get current language

    return (
        <a href={props.link} className={styles.link}>
            <span className={styles.mask}>
                <div className={styles.linkContainer}>
                    <span className={`${styles.linkTitle1} ${styles.title}`}>{props.buttonTxt}</span>
                    <span className={`${styles.linkTitle2} ${styles.title}`}>{props.buttonTxt}</span>
                </div>
            </span>
        </a>
    );
};

export default CtaButtonHover;
